/**
 * 页面权限
 */
export const RANKING_AUCTION_LIST_PAGE_UUID =
  'c2daad60-86fe-42ee-bb43-b9c593f5d3c3'
